import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { ListModule } from '@portal-core/ui/list/list.module';
import { LicenseUserTeamsListComponent } from './license-user-teams-list.component';


@NgModule({
  declarations: [
    LicenseUserTeamsListComponent
  ],
  imports: [
    CommonModule,
    ListModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    IncludedInModule,
    MatSnackBarModule,
    TeamAvatarModule
  ],
  exports: [
    LicenseUserTeamsListComponent
  ]
})
export class LicenseUserTeamsListModule { }
